var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.353 2.364C7.353 1.058 6.3 0 5 0 3.7 0 2.647 1.058 2.647 2.364c0 1.305 1.054 2.363 2.353 2.363 1.3 0 2.353-1.058 2.353-2.363z",
    transform: "translate(-153 -574) translate(120 563) translate(32 11) translate(2 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.294 11.49V8.406C.317 7.68.76 7.034 1.43 6.743c2.297-.893 4.849-.893 7.147 0 .67.29 1.112.938 1.135 1.664v2.078c0 .422-.17.827-.471 1.125-.301.298-.71.465-1.135.463H2.9",
    transform: "translate(-153 -574) translate(120 563) translate(32 11) translate(2 1)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileField);
export default __webpack_public_path__ + "static/media/profile-field.5c54c994.svg";
export { ForwardRef as ReactComponent };